/*
 *
 * ChangePasswordForm constants
 *
 */

export const SUBMIT = 'claris-vnext/ChangePasswordForm/SUBMIT';
